import React, { ReactNode, useCallback, useMemo, useRef, useState } from 'react';
import Modal from '@/components/shared/Modal';

// 二次确认框
interface PromptConfig {
  // Modal中的提示内容
  content?: ReactNode;
  // 需二次确认的操作，可异步可同步, 可返回boolean决定操作完成后是否需要关闭modal，不传默认为关闭
  operation?: () => boolean | void | Promise<boolean | void>;
}

interface UsePromptOutProps {
  // Modal组件
  Prompt: JSX.Element;
  // 打开Modal等待确认，可进一步设置，否则会
  setPrompt: (config?: PromptConfig) => void;
  // 关闭Prompt
  closePrompt: () => void;
}

export default (defaultConfig?: PromptConfig): UsePromptOutProps => {
  const defaultConfigRef = useRef(defaultConfig || {});

  const [show, setShow] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [currentConfig, setCurrentConfig] = useState<PromptConfig>(defaultConfig);

  const setPrompt = useCallback((config?: PromptConfig) => {
    setShow(true);
    setCurrentConfig({ ...defaultConfigRef.current, ...config });
  }, []);

  const closePrompt = useCallback(() => {
    setShow(false);
    setLoading(false);
  }, []);

  const handleConfirm = useCallback(() => {
    setLoading(true);
    Promise.resolve()
      .then(() => currentConfig?.operation())
      .then((shouldClose) => {
        setShow(shouldClose === false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentConfig?.operation]);

  const handleResetConfig = useCallback(() => {
    setCurrentConfig(defaultConfigRef.current);
  }, []);
  const Prompt = useMemo(
    () => (
      <Modal
        appearance="warning"
        show={show}
        confirmLoading={loading}
        onCancel={closePrompt}
        onConfirm={handleConfirm}
        onExited={handleResetConfig}
      >
        {currentConfig?.content}
      </Modal>
    ),
    [closePrompt, currentConfig?.content, handleConfirm, handleResetConfig, loading, show]
  );

  return {
    Prompt,
    setPrompt,
    closePrompt,
  };
};
